module.exports = __webpack_public_path__ + "img/85.8.TSS.b92fd549.png";